export class UserFilterSettingsModel {
  public name: string;
  public email: string;
  public alphaIndex: string;
  public isActive?: boolean;
  public isDeleted?: boolean;
}